import type { Territory } from '../data/jurisdictions';

// These IDs point to TerritoryConfig Entries
export const ProductionTerritoryConfigEntries: {
  [key in Territory]: string;
} = {
  AS: '6zcgmHKPpdOhRbQ7KPQuVk',
  GU: '1aHgnzkKlfh98n05c8nEDC',
  MP: '5oi63QWvsPlg0hgPAQVdeQ',
  PR: '2MIoWyMReQt0RMZKI0OFC1',
  VI: '7vNBoAbWzjfDr3B8H2nS1o',
};

// These are TestingTerritoryConfig Entries
// TestingTerritoryConfig entries are copies of
// TerritoryConfig objects safe for testing/experimentation
export const TestingTerritoryConfigEntries: {
  [key in Territory]: string;
} = {
  AS: '9Kndjt6Qmq0mYc8BwQeOb',
  GU: '1gEsIbwyIo5MyXtPGz8Pfo',
  MP: '3xKKNOzBgOYWU3lTiiRNHw',
  PR: '48SInyVmkm2urMmrQJHHhb',
  VI: '6pxRqfgqUxhaaEU1eDj5oi',
};
